import useDebounce from '@/common/hooks/useDebounce.ts';
import { vehicleTypeRequest } from '@/common/queries/selections/vehicleTypeRequest';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

const useVehicleTypeRequest = (options: { enabled: boolean }) => {
  const [vehicleTypeName, setVehicleTypeName] = useState<string>('');
  const debounce = useDebounce();
  const onVehicleTypeSearchChange = (value: string) => {
    if (value) {
      debounce(() => {
        setVehicleTypeName(value);
      }, 1000);
    } else {
      setVehicleTypeName(value);
    }
  };

  const vehicleTypeQuery = useQuery({
    enabled: options.enabled,
    queryKey: ['vehicleType', vehicleTypeName],
    queryFn: () => vehicleTypeRequest({ vehicleTypeName }),
    select: (data) =>
      data.results.map((item) => ({
        label: item.fa_name,
        value: item.id,
        enName: item.name,
      })),
  });
  return { vehicleTypeQuery, onVehicleTypeSearchChange };
};

export default useVehicleTypeRequest;
